// Use shared utilities for initialization and lifecycle
// eslint-disable-next-line import/no-extraneous-dependencies
const {
  initSelector,
  bindLifecycle,
  buildAjaxOptions,
} = require("./select2-utils");

export class Select2AjaxGetClients {
  start() {
    const selector = ".select2AjaxGetClients";

    const ajax = buildAjaxOptions(
      "/clientes/search.json",
      function (item) {
        return { text: item.name, id: item.id };
      },
      20
    );

    const minInput = 3;
    const init = () =>
      initSelector(selector, {
        minimumInputLength: minInput,
        maximumInputLength: 20,
        placeholder: "Pesquise e selecione (digite ao menos 3 caracteres)",
        allowClear: true,
        ajax,
        language: {
          inputTooShort: function (args) {
            return `Digite ao menos ${args.minimum} caracteres`;
          },
        },
        escapeMarkup: function (m) {
          return m;
        },
      });

    // run once now in case DOM events already fired
    try {
      init();
    } catch (e) {
      // ignore
    }

    bindLifecycle(init, selector);
  }
}
